import { render, staticRenderFns } from "./TestVariant.vue?vue&type=template&id=a8c24392&scoped=true&"
import script from "./TestVariant.vue?vue&type=script&lang=js&"
export * from "./TestVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c24392",
  null
  
)

export default component.exports